import { render } from "./orders.vue?vue&type=template&id=fbebea04&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=fbebea04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fbebea04"

export default script